function clamp(min, d, max) {
  return Math.max(min, Math.min(max, d));
}

export default function (e, bigBox) {
  const x = e.point.x;
  const y = e.point.y;

  const bigBoxRect = bigBox.getBoundingClientRect();
  const bb = this.tooltipContent.getBoundingClientRect();
  const left = clamp(20, x - bb.width / 2, window.innerWidth - bb.width - 20);

  let top;
  if (bigBoxRect.height > y + 80 + bb.height) {
    top = y + 40;
  } else {
    top = y - bb.height - 40;
  }

  this.tooltipContent.style.left = `${left}px`;
  this.tooltipContent.style.top = `${top}px`;
}
